import { Box, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";

import { Option } from "@/constants/investmentStyleDiagnosisQuestions";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: { display: "flex", flexDirection: "column", gap: 12 },
  row: { padding: 16, borderRadius: 12, backgroundColor: theme.palette.semantic["surface/base"] },
  label: { fontSize: 14, lineHeight: 1.5, marginBottom: 12, [theme.breakpoints.up("md")]: { fontSize: 16 } },
  options: { display: "flex", gap: 8 },
  option: {
    position: "relative",
    flex: 1,
    minWidth: 0,
    padding: "12px 4px",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: 9999,
    border: `1px solid ${theme.palette.semantic["border/default"]}`,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: 1.5,
    "&:focus-within": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    [theme.breakpoints.up("md")]: { fontSize: 14, padding: "8px 4px" },
  },
  selected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.semantic["state/selected-bg"],
    color: theme.palette.primary.main,
  },
  input: { position: "absolute", width: 1, height: 1, opacity: 0 },
}));

type AnxietyMatrixProps = {
  rows: { key: string; label: string }[];
  levels: Option<string>[];
  values: Record<string, string | undefined>;
  onChange: (key: string, level: string) => void;
};
export const DiagnosisInvestmentStyleAnxietyMatrix: React.FC<AnxietyMatrixProps> = ({
  rows,
  levels,
  values,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {rows.map((row) => (
        <Box key={row.key} className={classes.row} role="group" aria-label={row.label}>
          <Typography className={classes.label}>{row.label}</Typography>
          <Box className={classes.options}>
            {levels.map((level) => (
              <label
                key={level.value}
                className={clsx(classes.option, values[row.key] === level.value && classes.selected)}
              >
                <input
                  className={classes.input}
                  type="radio"
                  name={row.key}
                  value={level.value}
                  checked={values[row.key] === level.value}
                  onChange={() => onChange(row.key, level.value)}
                />
                {level.label}
              </label>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
